import { NavigationItem } from '@app/shared/models/navigation-item';

const items: NavigationItem[] = [
  new NavigationItem(
    'exhibition',
    'exhibition',
    'Home'
  ),
  new NavigationItem(
    'profile',
    'profile',
    'Profil'
  ),
  new NavigationItem(
    'settings',
    'settings',
    'Settings'
  ),
  new NavigationItem(
    'tutorial',
    'tutorial',
    'tutorial_title_1'
  ),
  new NavigationItem(
    'templates',
    'templates',
    'Templates'
  ),
  new NavigationItem(
    'about',
    'about',
    'About'
  ),
  new NavigationItem(
    'imprint',
    'imprint',
    'Imprint'
  )
];

export const navigationConfig = {
  items
};
